<template>
  <!--  <div>-->
  <div id="ambulanceInfo" class="affix-container">
    <div class="car-select-row">
      <div
        v-for="{name, id, statu} in realAmbulanceList"
        :key="id"
        class="car-item"
      >
        <div
          v-if="statu === '发车中'"
          @click="changePage(name, id)"
        >
          <img
            class="working"
            src="@/assets/photos/working.png"
            alt=""
            style="height: 100%"
          >
          <div>{{ name }}</div>
        </div>
        <div
          v-else
          @click="changePage(name, id)"
        >
          <img
            class="waiting"
            src="@/assets/photos/waiting.png"
            alt=""
            style="height: 100%"
          >
          <div>{{ name }}</div>
        </div>
      </div>
      <img
        class="exit-fullscreen"
        src="@/assets/icons/cleanMode/exit.png"
        alt=""
        @click="exitFullScrenBtn"
      >
    </div>
    <el-row class="fullscreen-row" type="flex" justify="space-between">
      <el-col :span="11.25">
        <!--          <div class="changeBtnGroup">-->
        <!--            &lt;!&ndash; 心電圖與B超切換 &ndash;&gt;-->
        <!--            <div class="changeBtn isActive">-->
        <!--              <img :src="currentShow" alt="" class="changeBtnImg">-->
        <!--              <img-->
        <!--                id="choosingBtn"-->
        <!--                src="@/assets/photos/aside-arrow-cleanMode-down.png"-->
        <!--                alt=""-->
        <!--                @click="isClick = !isClick"-->
        <!--              >-->
        <!--            </div>-->
        <!--            &lt;!&ndash; 心電圖與B超切換 &ndash;&gt;-->
        <!--            <div-->
        <!--              class="changeBtn"-->
        <!--              tabindex="1"-->
        <!--              :class="{ forChoosing: !isClick }"-->
        <!--              @click="changeBtnB"-->
        <!--            >-->
        <!--              <img-->
        <!--                src="@/assets/icons/cleanMode/b.png"-->
        <!--                alt=""-->
        <!--                class="changeBtnImg"-->
        <!--              >-->
        <!--            </div>-->
        <!--            &lt;!&ndash; 心電圖與B超切換 &ndash;&gt;-->
        <!--            <div-->
        <!--              class="changeBtn is-waiting"-->
        <!--              tabindex="2"-->
        <!--              :class="{ forChoosing: !isClick }"-->
        <!--              @click="changeBtnH"-->
        <!--            >-->
        <!--              <img-->
        <!--                src="@/assets/icons/cleanMode/heart.png"-->
        <!--                alt=""-->
        <!--                class="changeBtnImg"-->
        <!--              >-->
        <!--            </div>-->
        <!--          </div>-->
        <div class="diagram-background  video-player">
          <electrocardiogram
            :diogram-width="720"
            :diogram-height="540"
            :video-src="videoType2"
          />
          <span
            v-show="!hasEcgVideo"
            class="permission-button"
          >
            暂无视频
          </span>
        </div>
      </el-col>
      <el-col :span="11.25" class="car-video">
        <div class="car-video-background video-player">
          <carVideo
            :car-width="960"
            :car-height="540"
            :video-src="videoType1"
          />
          <!--这种属于直播类型的监控视频,只有 护士 || 信息科 需要请求权限-->
          <!-- 如果不是护士的话,下面的代码直接不用显示了 -->
          <el-button
            v-show="(userInfo.loginUserId === 3) && !hasPermission"
            class="permission-button"
            @click="getPermissionForLive"
          >
            <!-- 如果是护士的话,再看看有没有权限 -->
            请求权限
          </el-button>
          <span v-show="!hasVideo" class="permission-button">
              暂无视频
            </span>
          <!-- 这种属于直播类型的监控视频,只有护士需要请求权限 -->
          <!--            <div v-show="isNurse">-->
          <!--              <el-button-->
          <!--                v-if="!hasPermission"-->
          <!--                class="permissionBtn"-->
          <!--                @click="getPermissionForLive"-->
          <!--              >请求权限-->
          <!--              </el-button>-->
          <!--            </div>-->
        </div>
      </el-col>

    </el-row>

    <el-row class="fullscreen-row">
      <el-col :span="11.25" class="patient-info">
        <div class="patient-info-title"> 急救患者信息：</div>
        <div>
          <div class="ambulance-situation">
            <!-- // 第1行 -->
            <el-row>
              <el-col :span="3" :offset="1">
                <div>事例编号：</div>
              </el-col>
              <el-col :span="5" :offset="0">
                <div>{{ patient.number }}</div>
              </el-col>
              <el-col :span="3" :offset="1">
                <div>受理时间：</div>
              </el-col>
              <el-col :span="8" :offset="0">
                <div>{{ patient.formatTime }}</div>
              </el-col>
            </el-row>
            <!-- // 第二行 -->
            <el-row>
              <el-col :span="2" :offset="1">
                <div>阶段：</div>
              </el-col>
              <el-col :span="16" :offset="0">
                <div>
                  {{ carStage[patient.statu] }}，
                  {{ patient[carStageTime[patient.statu]] }}
                </div>
              </el-col>
            </el-row>
            <!-- // 第三行 -->
            <el-row>
              <el-col :span="2" :offset="1">
                <div>姓名：</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>{{ patient.name || "- " }}</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>性别：</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>{{ patient.gender || "- " }}</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>年龄：</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>{{ patient.age || "- " }}岁</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>联系电话：</div>
              </el-col>
              <el-col :span="5" :offset="0">
                <div>{{ patient.phoneNumber || "- " }}</div>
              </el-col>
            </el-row>
            <!-- // 第四行 -->
            <el-row>
              <el-col :span="2" :offset="1">
                <div>地址：</div>
              </el-col>
              <el-col :span="8" :offset="0">
                <div>{{ patient.patientAddr || "- " }}</div>
              </el-col>
              <el-col :span="2" :offset="1">
                <div>主诉：</div>
              </el-col>
              <el-col :span="9" :offset="0">
                <div>{{ patient.mainComplaint || "- " }}</div>
              </el-col>
            </el-row>
          </div>

          <div class="physical-situation">
            <el-row>
              <el-col :span="2" :offset="1">
                <div>体温：</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>{{ patient.temperature || "- " }}℃</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>呼吸：</div>
              </el-col>
              <el-col :span="4" :offset="0">
                <div>{{ patient.breath || "- " }}次/分</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>收缩压：</div>
              </el-col>
              <el-col :span="4" :offset="0">
                <div>{{ patient.systolicPressure || "- " }}mmHg</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>舒张压：</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>{{ patient.diastolicPressure || "- " }}mmHg</div>
              </el-col>
            </el-row>
          </div>

          <div class="patient-situation">
            <!-- <div>急救病人情况</div> -->
            <!-- // 第1行 -->
            <div class="patient-situation-title">描述及诊断信息：</div>
            <!-- // 第2行 -->
            <el-row>
              <el-col :span="3" :offset="1">
                <div>语音记录：</div>
              </el-col>
              <el-col :span="4" :offset="1">
                <div v-if="patient.wavList">共{{ getDescWav || 0 }}条</div>
              </el-col>
              <el-col :span="3" :offset="1">
                <div>初步诊断：</div>
              </el-col>
              <el-col :span="9" :offset="1">
                <div>{{ patient.fistCheck || "- " }}</div>
              </el-col>
            </el-row>
            <!-- // 第3行 -->
            <el-row>
              <el-col :span="3" :offset="1">
                <div>描述：</div>
              </el-col>
              <el-col :span="18" :offset="1">
                <div>{{ patient.details || "- " }}</div>
              </el-col>
            </el-row>
          </div>

          <div class="measures">
            <div class="measuresTitle">急救措施及用药：</div>
            <el-row>
              <el-col :span="3" :offset="1">
                <div>语音记录：</div>
              </el-col>
              <el-col :span="4" :offset="1">
                <div>共{{ getDrugWav || 0 }}条</div>
              </el-col>
              <el-col :span="3" :offset="1">
                <div>药剂：</div>
              </el-col>
              <el-col :span="9" :offset="1">
                  <span
                    v-for="{name, number, unit, rescueOrgan,id} in patient.costmedicalList"
                    :key="id"
                  >{{ name }} &nbsp;&nbsp; {{ number }} {{ unit }}&nbsp; &nbsp;{{ rescueOrgan }};&nbsp; &nbsp; </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" :offset="1">
                <div>操作：</div>
              </el-col>
              <el-col :span="18" :offset="1">
                <div>{{ patient.operationM || "- " }}</div>
              </el-col>
            </el-row>
          </div>
          <!-- </div> -->
        </div>
      </el-col>

      <el-col :span="11.25" class="swiper-info">
        <el-carousel
          indicator-position="none"
          height="530px"
          arrow="never"
          :autoplay="true"
          :loop="true"
        >
          <!--            <el-carousel-item>-->
          <!--              <div class="ambulanceState">-->
          <!--                <div class="ambulanceStateTitle">-->
          <!--                  <span class="spanTitle">急救车进程：</span>-->
          <!--                </div>-->
          <!--                <div-->
          <!--                  v-for="car in carList"-->
          <!--                  :key="car.ambulanceId"-->
          <!--                  class="ambulanceStateContainer"-->
          <!--                >-->
          <!--                  <span>{{ carObject[car.ambulanceId] }}({{ carPlate[car.ambulanceId] }}) </span>-->
          <!--                  <div class="steps">-->
          <!--                    <el-steps :active="car.statu - 1" align-center>-->
          <!--                      <el-step-->
          <!--                        v-if="car"-->
          <!--                        :title="car['_turout_time']"-->
          <!--                        description="出车时刻"-->
          <!--                      />-->
          <!--                      <el-step-->
          <!--                        v-if="true"-->
          <!--                        :title="car['_arrived_time']"-->
          <!--                        description="抵达现场"-->
          <!--                      />-->
          <!--                      <el-step-->
          <!--                        v-if="car"-->
          <!--                        :title="car['_board_time']"-->
          <!--                        description="患者上车"-->
          <!--                      />-->
          <!--                      <el-step-->
          <!--                        v-if="car"-->
          <!--                        :title="car['_done_time']"-->
          <!--                        description="到达医院"-->
          <!--                      />-->
          <!--                    </el-steps>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </el-carousel-item>-->
          <el-carousel-item>
            <div class="predicate-time-group">
              <!--                <div style="display: none">{{ iddd }}</div>-->
              <div
                v-for="current_car in leftTimeList"
                :key="current_car.id"
                class="predicate-time"
              >
                {{ current_car.name }} 预计花费时间：<span>{{ current_car.time }}分钟</span>
              </div>
            </div>

            <clean-mode-map
              :get-left-time="getLeftTime"
            />
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>

    <!-- 暂无急救任务弹窗 -->
    <my-dialog
      :width="390"
      title="提示"
      :dialog-carted="dialogInfo"
      @confirmOk="dialogInfo = false"
    >
      <template #content>
        <div>{{ dialogInfoMessage }}</div>
      </template>
    </my-dialog>
  </div>
  <!--  </div>-->
</template>

<script>
import CleanModeMap from "@components/MapContainer/CleanModeMap";
import CarVideo from "@/components/stream/CarVideo";
import Electrocardiogram from "@/components/stream/Electrocardiogram";
import screenfull from "screenfull";
// import { getPermission } from "@/api/user.js";
import { askPermission } from "@/api/permission.js";
import { getAmbulanceInfo } from "@/api/ambulanceList.js";
import MyDialog from "@components/customDialog/MyDialog.vue";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper/core";
import { mapState } from "vuex";
import { getStreamToken } from "@api/streamdata";
import { srsRtcUrl } from "@/utils/basic";
import { showWindowMessage } from "@utils/notification";
import { getAmbulanceStageStatus, carStageTime } from "@/utils/basic";

SwiperCore.use([Autoplay, Pagination, Navigation]);

export default {
  name: "CleanMode",
  components: {
    CarVideo,
    Electrocardiogram,
    CleanModeMap,
    MyDialog,
  },
  data() {
    return {
      // forChoosing: "changeBtn",
      // forChoosingStatus: 0,
      // checkPermissionTimer: null, // 检查护士 信息科 是否拥有权限的timer
      carList: [], // 急救车轮播图状态展示
      isNurse: false, // 判断是否为护士登陆
      hasPermission: false, // 判断护士是否有权限, 如果有权限,则为true
      hasVideo: false, // 监控视频
      hasEcgVideo: false, //  心电图视频
      carID: 0,
      patient: [],
      dialogInfo: false,
      dialogInfoMessage: "",
      leftTimeList: [], // 急救车返程所需时间 || 这是一个列表
      videoType2: "", // 摄像头和麦克风
      videoType1: "", // 救护仪器
      carStage: getAmbulanceStageStatus,
      carStageTime: carStageTime,
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      hospitalID: "hospitalID",
      userInfo: "userInfo",
      carObject: "carObject",
      carPlate: "carPlate",
      currentList: "currentList"
    }),
    realAmbulanceList() {
      return this.ambulanceLists.filter(car => {
        return car.type === "急救车";
      });
    },
    getDescWav() {
      const { wavList } = this.patient;
      let count = 0;
      wavList?.forEach(({ fromW }) => {
        if (fromW === "描述语音") {
          count = count + 1;
        }
      });
      return count;
    },
    getDrugWav() {
      const { wavList } = this.patient;
      let count = 0;
      wavList?.forEach(({ fromW }) => {
        if (fromW === "急救语音") {
          count = count + 1;
        }
      });
      return count;
    }
  },
  watch: {
    currentList: {
      handler(val) {
        this.getMessage(val);
        console.log("watch the currentList change!");
      },
      immediately: true
    }
  },
  beforeUnmount() {
    // window.clearInterval(this.checkPermissionTimer);
    // this.checkPermissionTimer = null;
  },

  mounted() {
    this.carID = this.$route.params.id * 1;
    this.fullscreenBtn();
    // this.checkPermission(); // 检查护士是否有查看监控的权限
    this.getStreamInfo();
    this.getMessage(this.currentList);
  },
  methods: {
    fullscreenBtn() {
      const element = document.getElementById("ambulanceInfo");
      if (!screenfull.isFullscreen) {
        if (screenfull.isEnabled) {
          screenfull.request(element);
        }
      }
    },
    getMessage(missions) {
      if (missions.length === 0) return;
      this.carList = missions;
      const mission = missions.find(mission => {
        return mission.ambulanceId === this.carID;
      });
      if (!mission) {
        this.patient = {};
      } else {
        this.patient = mission;
      }
    },
    // 拉取webrtc视频流 || 进来的时候 (两个都拉)
    async getStreamInfo() {
      try {
        // "ecg": 1, // 0代表无人车/机没有心电图视频，1代表有心电图视频，2代表心电图视频没有在推
        // "live": 0, // 0代表没有权限，1代表有权限可以播放，2代表监控视频没有在推
        const { code, data, status } = await getStreamToken(this.carID);
        if (code === 200) {
          const { live, ecg } = status;
          if (live === 0) {
            this.hasPermission = false;
            this.hasVideo = true;
          } else if (live === 1) {
            const type1 = data.find(e => {
              return e.type === 1;
            });
            if (type1) {
              this.hasPermission = true;
              this.hasVideo = true;
              this.videoType1 = srsRtcUrl + `${type1.app}/${type1.stream}?token=${type1.token}&time=${Date.now()}`; // 摄像头和麦克风
            }
          } else {
            // 2
            this.hasPermission = true;
            this.hasVideo = false;
          }
          this.hasEcgVideo = ecg === 1;
          const type2 = data.find(e => {
            return e.type === 2;
          });

          if (type2) {
            this.videoType2 = srsRtcUrl + `${type2.app}/${type2.stream}?token=${type2.token}&time=${Date.now()}`; // 救护仪器
          }
        } else {
          this.hasPermission = true;
          this.hasVideo = false;
          this.videoType1 = srsRtcUrl + "";
          this.videoType2 = srsRtcUrl + "";
        }
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    getLeftTime(leftTime) {
      this.leftTimeList = leftTime;
    },
    // checkPermission() {
    //   const { loginUserId, id: userId } = this.userInfo;
    //   this.isNurse = loginUserId === 3;
    //   if (!this.isNurse) { // 不是护士之类的直接就能看, 护士的话, 需要申请权限
    //     this.hasPermission = true;
    //     return;
    //   }
    //   // 查询当前用户是否已经有 监控视频权限
    //   const form = {
    //     userId,
    //     type: "checkUserPermission",
    //     checkAmbulanceId: this.carID
    //   };
    //   getPermission(form)
    //     .then(({ code }) => {
    //       /*
    //       * 等于1 即是有权限 有权限,可以看 可能护士已经申请过了,并且已经通过了
    //       * */
    //       this.hasPermission = code === "1";
    //       if (this.checkPermissionTimer && code === "1") {
    //         clearInterval(this.checkPermissionTimer);
    //         this.checkPermissionTimer = null;
    //       }
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
    // 如果护士没有权限,则去请求权限
    async getPermissionForLive() {
      const form = {
        type: "checkLive",
        userId: this.userInfo.id,
        hospitalId: this.hospitalID,
        ambulanceId: this.carID
      };
      const { code } = await askPermission(form);
      this.dialogInfo = true;
      this.dialogInfoMessage = code === "1" ? "请求成功,请等待管理员通过" : "未知错误,请联系开发人员";
      // 在这之后, 循环请求是否已经拥有权限
      // this.checkPermissionTimer = window.setInterval(() => {
      //   // this.checkPermission();
      // }, 5000);
    },
    changeBtnB() {
      // 切换B超
      // this.isClick = false;
      // if (this.forChoosingStatus === 0) {
      //   this.forChoosing = "changeBtn";
      //   this.forChoosingStatus = 1;
      // } else {
      //   this.forChoosing = "is-waiting";
      //   this.forChoosingStatus = 0;
      // }
    },
    // 切换心电图
    changeBtnH() {
      // this.isClick = false;
    },

    exitFullScrenBtn() {
      if (screenfull.isEnabled) {
        screenfull.exit();
        // this.addSomething();
        this.$router.push("/index").then(err => {
          console.log(err);
        });
      }
    },
    // 网络请求一下,判断是否真的没有任务
    async changePage(name, id) {
      const { statu } = await getAmbulanceInfo(id);
      if (statu === "等待") {
        this.dialogInfo = true;
        this.dialogInfoMessage = `本车: ${name}暂无急救任务!`;
      } else {
        await this.$router.push("/cleanMode/" + id);
      }
    },
  },
};
</script>

<style scoped lang='scss'>
@import "../assets/css/cleanMode";

.video-player {
  background: #666666;
  border-radius: 10px;
  position: relative;

  .permission-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.diagram-background {
  width: 900px;
  height: 540px;
  background: #666666;
  position: relative;

  > div {
    margin: 0 auto;
  }

  .electrocardiogram {
    width: 482px;
    height: 360px;
  }
}

.car-select-row {
  display: flex;
  border: 1px solid #ccc;
  background: #e4e1e1;
  justify-content: space-around;
  width: 400px;
  overflow-x: auto;
  align-items: center;
  opacity: .6;
  position: fixed;
  top: 0;
  right: 50%;
  transform: translateX(50%);
  z-index: 2;
  padding: 16px;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  .exit-fullscreen {
    width: 40px;
  }

  .car-item {
    height: 45px;
    text-align: center;
    vertical-align: middle;
    padding-bottom: 10px;
  }

  img.working {
    width: 51px;
    height: 33px;
  }

  img.waiting {
    width: 49px;
    height: 33px;
  }
}

.predicate-time-group {
  position: absolute;
  left: 10px;
  bottom: 4px;
  background: #efefef;
  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
  z-index: 161;
  text-align: center;
  vertical-align: bottom;
  font-size: 22px;
  font-weight: bold;
  color: #666666;

  .predicate-time {
    min-width: 280px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    padding: 0 3px;
    position: absolute;
    z-index: 200;
  }
}

#ambulanceInfo {
  background: #333333;

  .fullscreen-row {
    width: 1875px;
    margin: 0 auto;
  }

  .swiper-info {
    width: 960px;
    height: 530px;
    margin-left: 10px;
    position: relative;
  }

}

.car-video {
  position: relative;

  .el-button {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .car-video-background {
    width: 960px;
    height: 540px;
    background: #666666;
    margin-left: 10px;
    position: relative;
  }
}

.patient-info {
  width: 900px;
  height: 530px;
  overflow-y: scroll;
  background: #e4e1e1;

  .patient-info-title {
    width: 160px;
    height: 40px;
    background: #f4f4f4;
    box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
    text-align: center;
    padding-left: 10px;
    line-height: 40px;
    font-size: 20px;
    font-weight: bold;
    color: #333333;
  }

  .ambulance-situation {
    width: 815px;
    background: #f4f4f4;
    border-radius: 10px;
    margin-left: 43px;
    margin-top: 30px;
    line-height: 2;
  }

  .physical-situation {
    width: 815px;
    background: #f4f4f4;
    border-radius: 10px;
    margin-left: 43px;
    margin-top: 20px;
    line-height: 2;
  }

  .patient-situation {
    width: 815px;
    background: #f4f4f4;
    border-radius: 10px;
    margin-left: 43px;
    margin-top: 20px;
    line-height: 2;

    .patient-situation-title {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin-left: 10px;
    }
  }
}

.measures {
  width: 815px;
  background: #f4f4f4;
  border-radius: 10px;
  margin-left: 43px;
  margin-top: 20px;
  line-height: 2;

  .measuresTitle {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    margin-left: 10px;
  }
}

//.changeBtnGroup {
//  position: absolute;
//  left: 0;
//  top: 0;
//  z-index: 1;
//
//  .changeBtn {
//    width: 80px;
//    height: 70px;
//    cursor: pointer;
//    margin-bottom: 0;
//
//    background: #efefef;
//
//    text-align: center;
//    // line-height: 70px;
//  }
//}

//.changeBtnImg {
//  width: 50px;
//  height: 50px;
//  margin-top: 10px;
//}

//.is-waiting {
//  background: #e4e1e1;
//}

// 按钮组相关操作
//.forChoosing {
//  display: none;
//}

//.isActive {
//  position: relative;
//  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.6) inset;
//}

//#choosingBtn {
//  display: inline-block;
//  position: absolute;
//  width: 12px;
//  height: 6px;
//  top: 50%;
//  transform: translateY(-50%);
//  padding: 10px 1px;
//  right: 1px;
//}


//.swiperTest {
//  background: #0c618b;
//  margin: auto;
//  width: 200px;
//  height: 100px;
//  text-align: center;
//}

//.fullscreen {
//  position: absolute;
//  width: 50px;
//  height: 50px;
//  right: 0;
//  bottom: 0;
//  background: #efefef;
//  text-align: center;
//  line-height: 50px;
//  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
//  cursor: pointer;
//
//  img {
//    width: 31px;
//    height: 31px;
//    vertical-align: middle;
//  }
//}

//.fullscreenPage {
//
//}

//#panel {
//  height: 400px;
//  top: 500px;
//}
//.permissionBtn {
//  position: absolute;
//  right: 424px !important;
//  bottom: 214px;
//  height: 50px;
//  background: #0c618b70;
//  box-shadow: 0 0 6px 0 rgb(6, 53, 76);
//  border-radius: 6px;
//  font-size: 18px;
//
//  font-weight: bold;
//  color: #efefef;
//}
//.ambulanceStateContainer {
//  display: flex;
//  justify-content: center;
//  align-items: center;
//
//  span {
//    color: #333333;
//  }
//}

//.ambulanceStateTitle {
//  width: 160px;
//  height: 40px;
//  background: #f4f4f4;
//  text-align: center;
//  box-shadow: 0px 0px 6px 0px rgba(6, 53, 76, 0.5);
//
//  .spanTitle {
//    // margin: 0 auto;
//    display: inline-block;
//    padding-left: 10px;
//    line-height: 40px;
//    text-align: center;
//    font-size: 20px;
//
//    font-weight: bold;
//    color: #333333;
//  }
//}
</style>
